import { indexRoutes, IndexRoutesType } from './routes/index-routes';

export const useRoutes = (): { routes: IndexRoutesType } => {
  const routes = indexRoutes();

  return { routes };
};
